import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Radio from '@mui/material/Radio';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { getMultisiteNetworkConfigOptions } from '~/scenes/Cloud/utils/helpers';

type MultisiteOptionProps = {
  option: ReturnType<typeof getMultisiteNetworkConfigOptions>[number];
  isSelected: boolean;
  onSelect: () => void;
};
const MultisiteOption: React.FC<MultisiteOptionProps> = ({
  option: { title, description, testId },
  isSelected,
  onSelect,
}) => {
  return (
    <Card
      data-testid={testId}
      variant={isSelected ? 'selected' : 'contained'}
      data-variant={isSelected ? 'selected' : 'contained'}
      onClick={onSelect}
    >
      <CardActionArea>
        <CardContent>
          <Stack direction="row" spacing={1}>
            <Radio checked={isSelected} />
            <Stack direction="column">
              <Typography variant="h3">{title}</Typography>
              <Typography variant="body2">{description}</Typography>
            </Stack>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};
export default MultisiteOption;
